/* Add Staffing Management Dec 10, 2022 */
/* Add p_recData and Competitors Bids   Apr 11, 2026 */
<template lang="pug">
	div(class="kb-business-insights")
		div(class="bi-header")
			div(class="oppr-val")
				span Opportunity Value: 
				span {{c_opprValue}}
			div(class="small")
				b-button(class="btn-refresh" title="Refresh" variant="outline-secondary" @click="m_refreshClick")
					fa-icon(icon="sync")
		//- Loading
		kt-spinner(v-if="d_loading" p_txt="Business Insights")
		div(class="bi-content" v-show="!d_loading")
			div(class="cost")
				span Cost to Submit Proposal
								
				div(class="form-group")
					label Fee
					b-input-group(size="sm" prepend="$")
						b-form-input(:value="m_biValFmtNum(12)" disabled placeholder="Calculated")
					b-input-group(size="sm" prepend="%" class="pct")
						b-form-input(type="number" min=0 max=100 step=.01 :value="m_biVal(11)" @change="m_biValChg($event,11)")

				div(class="form-group")
					label Discount
					b-input-group(size="sm" prepend="$")
						b-form-input(:value="m_biValFmtNum(14)" disabled placeholder="Calculated")
					b-input-group(size="sm" prepend="%" class="pct")
						b-form-input( type="number" min=0 max=100 step=.01 :value="m_biVal(13)" @change="m_biValChg($event,13)")
					
				div(class="form-group")
					label Fee After Discount
					b-input-group(size="sm" prepend="$")
						b-form-input(:value="m_biValFmtNum(15)" disabled placeholder="Calculated")
				div(class="form-group")
					label Estimated Proposal Cost
					b-input-group(size="sm" prepend="$")
						b-form-input(:value="m_biValFmtNum(16)" :state="m_isNaN(16)" @change="m_biValChg($event,16)" placeholder="Enter Cost")
				div(class="form-group")
					label Actual Proposal Cost
					b-input-group(size="sm" prepend="$")
						b-form-input(:value="m_biValFmtNum(17)" :state="m_isNaN(17)" @change="m_biValChg($event,17)" placeholder="Enter Cost")
			div(class="create-staffing")
				kt-create-staffing(p_recordContext="opportunityId" :p_recordId="p_recInfo.Id" :p_teamMembers="d_refData.teamMemberId" :p_staffingData="c_staffingData")
			div(class="competitor-bids")
				kt-competitor-bids(:p_recData="p_recData" )
			div(class="proj-notes")
				span Project Assessment
				div(class="form-group" v-for="p in d_biProps.filter(x => m_isPN(x.id))" :key="p.id")
					label {{p.name}}
					div
						div(class="notes-list" v-show="(m_biVal(p.id, true)||[]).length>0")
							div(v-for="(item,ix) in m_biVal(p.id, true)" :key="ix" class="note" )
								input(type="text" :value="item.value" @change="m_chgNote($event, ix, p.id)" 
									:placeholder="'Enter a '+p.name" title="Click to Edit")
								b-button(class="btn-remove-note" variant="none" title="Remove" @click="m_remNote(ix, p.id)")
									fa-icon(icon="times")
								//Suggestions Dropdown/AutoComplete
						b-button(class="btn-add-note" variant="outline-primary" title="Add" @click="m_addNote($event, p.id)")
							fa-icon(icon="plus") 
							| Add

		//- Footer
		div(class="bi-footer" v-show="!d_loading")
			b-button(class="btn-save" title="Save" variant="primary" @click="m_save") Save
</template>

<script>

import {fn_getBusinessInsights, fn_saveBusinessInsights} from "@/utils/api.js";
import {kbdpAlert, fn_calcSum, fn_fmtMoney} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import KTList from "@/components/Ctrl/KT-List.vue";
import KTCreateStaffing from "@/components/Ctrl/KT-CreateStaffing.vue";
import KTCompetitorBids from "@/components/Ctrl/KT-CompetitorBids.vue";
export default {
	name: "kb-business-insights",
	components: {
		'kt-list': KTList,
		'kt-create-staffing':KTCreateStaffing,
		'kt-competitor-bids':KTCompetitorBids,
	},
	created() {
		fn_getData(this);
	},
	data() {
		return {
			d_biProps: refData.businessInsightProps,
			d_biData: [],
			d_loading: null,
			d_refData:[],
			d_staffingData:[],
			d_competitorBids:[],
		};
	},
	props: {
		p_recInfo: Object,
		p_recData: Object,
	},
	computed: {
	    c_staffingData(){ return this.d_staffingData;},
	    c_competitorBids(){ return this.d_competitorBids;},
		c_opprValue() {
			return fn_fmtMoney(this.p_recInfo.opprValue, false) || 'Not Entered';
		},

		c_feeVal() {
			return this.m_biVal(11) * this.p_recInfo.opprValue / 100;
		},
		c_discVal() {
			return this.m_biVal(13) * this.c_feeVal / 100;
		},
		c_feeAftrDisc() {
			return this.c_feeVal - this.c_discVal;
		},
		c_totalPSC() {
			let d = this.d_biData.filter(x => this.m_isPSC(x.propId)).map(x => Number(x.value));
			return fn_calcSum(d, true);
		},
	},
	methods: {
		m_isPS(propId) { //Project Staff
			return propId >= 21 && propId <= 27;
		},
		m_isPSC(propId) { //Project Staff Cost
			return propId >= 31 && propId <= 37;
		},
		m_isPN(propId) { //Project Notes
			return propId >= 51 && propId <= 54;
		},
		m_biVal(propId, isArry) {
			//Used by both scalar and Proj staff props
			let biVal = this.d_biData.filter(x => x.propId == propId)[0] || {};
			return isArry ? biVal.values : biVal.value;
		},
		m_biValFmtNum(propId) {
			let val = this.m_biVal(propId);
			if (val) val = val.toString().replace(',', '');
			return isNaN(val) ? val : Number(val).toLocaleString('en');
		},
		m_biValChg(chgVal, propId, isArry, biId) {
			//Used by both scalar and Proj staff props
			let biVal = this.d_biData.filter(x => x.propId == propId)[0];
			if (!biVal) {
				biVal = {propId};
				helper(); //Need to do this before pushing or else, no reactivity
				this.d_biData.push(biVal);
			}
			else {
				helper();
			}
			function helper() {
				if (isArry) biVal.values = chgVal;
				else {
					biVal.value = chgVal;
					if (biId) biVal.biId = biId;
				}
			}

		},
		m_isNaN(propId) {
			let val = this.m_biVal(propId);
			if (val) val = val.toString().replaceAll(',', '');
			return val ? isNaN(val) ? false : null : null;
		},

		m_addNote(e, propId) {
			let notes = this.d_biData.filter(x => x.propId == propId)[0];

			if (!notes) {
				this.d_biData.push({propId, values: [{value: null}]});
			}
			else {
				let len = notes.values.length;

				if (len == 0 || notes.values[len - 1].value !== null) {
					notes.values.push({value: null});
				}
			}

			setTimeout(() => {
				let cliElem = $(e.target)
					.siblings('.notes-list')
					.find(".note")
					.last()
					.children("input:text");
				cliElem.focus();
			}, 100);
		},
		m_remNote(ix, propId) {
			let notes = this.d_biData.filter(x => x.propId == propId)[0];
			notes.values.splice(ix, 1);
		},
		m_chgNote(e, ix, propId) {
			let notes = this.d_biData.filter(x => x.propId == propId)[0];
			notes.values[ix].value = e.target.value.trim() || null;
		},


		m_save() {

			let invalid = $(this.$el).find('.bi-content .form-group ').find(":invalid, .is-invalid").length > 0;
			if (invalid) {
				kbdpAlert.showErr("Inalid value(s) found, please correct and try again");
			} else {
				kbdpAlert.clear();
				fn_saveData(this);
			}

		},
		m_refreshClick() {
			fn_getData(this);
		}
	},
	watch: {
		c_totalPSC(nv) {
			if (isNaN(nv)) return;
			this.m_biValChg(nv, 30);
		},
		c_feeVal(nv) {
			if (isNaN(nv)) return;
			this.m_biValChg(nv, 12);
		},
		c_discVal(nv) {
			if (isNaN(nv)) return;
			this.m_biValChg(nv, 14);
		},
		c_feeAftrDisc(nv) {
			if (isNaN(nv)) return;
			this.m_biValChg(nv, 15);
		},
	}
};



function fn_getData(vc) {
	vc.d_loading = true;
	fn_getBusinessInsights(vc.p_recInfo.Id).then(resp => {
		vc.d_loading = null;
		fn_biDataParser(vc, resp);
	});
}
function fn_saveData(vc) {

	let biData = [];
	vc.d_biData.forEach(x => {
		let propId = x.propId;
		if (x.value) {
			biData.push({id: (x.biId || null), propId, value: x.value});
		}
		else if (x.values) {
			x.values.forEach(xv => {
				let value = xv.teamMemberId || xv.value;
				biData.push({id: (xv.biId || null), propId, value});
			});
		}
	});

	kbdpAlert.showSaving('Business Insights');
	fn_saveBusinessInsights(vc.p_recInfo.Id, biData).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to save Business Insights ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		fn_biDataParser(vc, resp);
		kbdpAlert.showOk('Business Insights were saved successfully');
	});
}


function fn_biDataParser(vc, resp) {
	let respBi = resp.businessInsights || [];
	vc.d_refData = resp.refData;
	vc.d_staffingData=resp.staffingData;
	let respRd = resp.refData;

	vc.d_biProps.filter(x => vc.m_isPS(x.id)).forEach(x => {
		let vals = respBi.filter(bix => bix.propId == x.id);
		if (vals.length > 0) {
			vals = vals.map(v => ({
				biId: v.id, ...respRd.teamMemberId.filter(tm => tm.teamMemberId == v.value)[0]
			}));
			vc.m_biValChg(vals, x.id, true);
		}
	});

	vc.d_biProps.filter(x => vc.m_isPN(x.id)).forEach(x => {
		let vals = respBi.filter(bix => bix.propId == x.id);
		if (vals.length > 0) {
			vals = vals.map(v => ({biId: v.id, value: v.value}));
			vc.m_biValChg(vals, x.id, true);
		}
	});

	vc.d_biProps.filter(x => !vc.m_isPS(x.id) && !vc.m_isPN(x.id)).forEach(x => {
		let val = respBi.filter(bix => bix.propId == x.id)[0];
		if (val) {
			vc.m_biValChg(val.value, x.id, false, val.id);
		}
	});
}

</script>

<style lang="less">
div.kb-business-insights {
	div.bi-header {
		display: flex;
		padding-top: 0.4em;
		.oppr-val {
			flex-grow: 1;
			text-align: left;
			font-size: 0.9em;
			> span:last-child {
				font-weight: bolder;
			}
		}
		.btn-refresh {
			font-size: 1em;
			margin-right: 0.3em;
			padding: 0em 0.3em;
		}
	}
	div.bi-content {
		text-align: left;
		font-size: 0.9em;
		// display: flex;
		// flex-wrap: wrap;
		> div.cost,
		> div.proj-staff,
		> div.proj-notes {
			border-bottom1: solid 0.2em #ced4da;
			margin: 0em 0;
			> .form-group {
				display: flex;
				flex-wrap: wrap;
				label {
					min-width: 150px;
					max-width: 200px;
					flex: 1;
					margin: auto 0;
				}

				input:invalid {
					border-color: #dc3545;
					box-shadow: none;
				}
			}
			> span:first-child {
				font-weight: bolder;
				display: inline-block;
				padding: 0.5em 0;
				font-size: 0.9em;
			}
		}
		> div.cost {
			.form-group {
				flex-wrap: nowrap;
				.input-group {
					flex-wrap: nowrap;
					min-width: 100px;
					width: 150px;
				}
				.input-group.pct {
					width: 100px;
					margin-left: 1em;
				}
			}
		}
		> div.proj-staff {
			.form-group {
				margin-bottom: 0.2em;
			}
			.form-group > div {
				display: flex;
				flex-wrap: wrap;
				.kt-list {
					min-width: 300px;
					margin-right: 0.5em;
					margin-bottom: 0.2em;
				}
				.cost {
					// min-width: 100px;
					width: 120px;
					margin: auto 0;
				}
			}
			.form-group.total {
				max-width: 627px;
				margin-bottom: 1em;
				label {
					margin: auto 0.8em auto auto;
					font-weight: bolder;
					text-align: right;

					@media (max-width: 787px) {
						margin-left: unset;
						min-width: 300px;
					}
					@media (max-width: 637px) {
						text-align: unset;
					}
				}
			}
		}
		> div.proj-notes {
			.form-group > div {
				width: 425px;
				.notes-list {
					min-width: 300px;

					border: solid 0.1em #dee2e6;
					border-radius: 0.25em;
					padding: 0.2em 0.3em;

					margin-bottom: 0.4em;
					overflow-y: auto;
					min-height: 100px;
					height: 100px;
					// max-height: 600px;
					resize: both;
					max-height: 400px;
				}
				.notes-list > .note {
					position: relative;
					border-bottom: solid 0.1em #dee2e6;
					font-size: 0.9em;
					display: flex;

					input[type="text"] {
						border: solid 0.1em #fff;
						border-radius: 0.15em;
						flex-grow: 1;
						padding-left: 4px;
						padding-right: 25px;
						&:focus {
							border-color: #adb5bd;
							background-color: #f8f9fa;
							outline: none;
						}
						&:hover {
							border-color: #ced4da;
						}
					}
					.btn-remove-note {
						opacity: 0.5;
						font-size: 0.8em;
						background-color: #e9ecef;
						box-shadow: unset;
						position: absolute;
						top: 50%;
						right: 0.3em;
						transform: translateY(-50%);
						padding: 0 0.3em;
						&:hover {
							opacity: unset;
						}
					}
				}

				.btn-add-note {
					display: block;
					font-size: 0.8em;
					line-height: 1em;
					padding: 0.2em 0.3em;
					svg {
						font-size: 0.9em;
					}
				}
			}
		}
	}
	div.bi-footer {
		padding-top: 0.5em;
		text-align: left;
		.btn-save {
			padding: 0.1em 0.4em;
		}
	}
}
create-staffing{
	margin-bottom: 1em;
}
</style>